import { render, staticRenderFns } from "./singleAreaChart.vue?vue&type=template&id=021f1e23&scoped=true&"
import script from "./singleAreaChart.vue?vue&type=script&lang=js&"
export * from "./singleAreaChart.vue?vue&type=script&lang=js&"
import style0 from "./singleAreaChart.vue?vue&type=style&index=0&id=021f1e23&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021f1e23",
  null
  
)

export default component.exports